import $ from 'jquery'
import Swiper from 'swiper/bundle'

const buttons = $('.hero__button')
const ctaMoreText = $('.hero__button--more')

const instance = new Swiper('.hero__slider', {
  slidesPerView: 1,
  on: {
    init() {
      buttons.removeClass('hero__button--active')
      buttons.eq(0).addClass('hero__button--active')
    },
    slideChangeTransitionStart(swiper) {
      buttons.removeClass('hero__button--active')
      buttons.eq(swiper.activeIndex).addClass('hero__button--active')

      ctaMoreText.text(orecaObject.homeCtaDefaultText)
      ctaMoreText.eq($(this).index()).text(orecaObject.homeCtaTexts[$(this).index()])
    },
  },
})

if (instance.imagesLoaded <= 0) {
  buttons.removeClass('hero__button--active')
  buttons.eq(0).addClass('hero__button--active')
}

ctaMoreText.text(orecaObject.homeCtaDefaultText)
ctaMoreText.eq(0).text(orecaObject.homeCtaTexts[0])

buttons.on('mouseover', function () {
  if (instance.imagesLoaded <= 0) {
    buttons.removeClass('hero__button--active')
    buttons.eq($(this).index()).addClass('hero__button--active')

    ctaMoreText.text(orecaObject.homeCtaDefaultText)
    ctaMoreText.eq($(this).index()).text(orecaObject.homeCtaTexts[$(this).index()])
  }
  else {
    instance.slideTo($(this).index())
  }
})
